import React, { FC, useState } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SectionWrapper } from '../SectionWrapper';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ButtonComponent } from '../ButtonComponent';
import { PartnerDetailsFeesModal } from './PartnerDetailsFeesModal';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { fetchPartnersFees } from '../../store/merchnts/actions/partners';
import { IPartnerFees } from '../../store/merchnts/merchant-interfaces';

export const PartnerDetailsFees: FC = () => {
	const { t } = useTranslation();
	const { partnerId } = useParams();

	const { merchantState: { partnerFees, isPartnerDetailsDataLoading }, dispatch } = useMerchants();

	const [feeModalState, setFeeModalState] = useState<{ isOpen: boolean, partnerFeeData?: IPartnerFees }>({
		isOpen: false,
		partnerFeeData: null,
	});
	const [modalState, setModalState] = useState<IModalWindow>({
	isOpen: false
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
	const closeFeeModal = (): void => setFeeModalState(prev => ({ ...prev, isOpen: false }));
	const handleSuccess = (): void => {
		closeFeeModal();
		setModalState({
      isOpen: true,
      modalTitle: feeModalState?.partnerFeeData ? 'Edit partner fee' : 'Add partner fee',
      content: (
        <div className="fs-6">
	        {feeModalState?.partnerFeeData ? 'Partner fee was changed successfully!' : 'Partner fee was added successfully!'}
        </div>
      ),
      confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
      minHeight: 100,
      onConfirm: async (): Promise<void> => {
				closeModal();
	      await fetchPartnersFees(dispatch, partnerId);
      },
      onClose: closeModal
    });
	};

	const handleError = (): void => {
		closeFeeModal();
		setModalState({
      isOpen: true,
      modalTitle: feeModalState?.partnerFeeData ? 'Edit partner fee' : 'Add partner fee',
      content: (
        <div className="fs-6">
	        {feeModalState?.partnerFeeData ? 'Failed changing partner fee.' : 'Failed adding partner fee.'}
        </div>
      ),
      confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
      minHeight: 100,
      onConfirm: () => {
	      closeModal();
	      setFeeModalState(prev => ({ ...prev, isOpen: true }));
      },
      onClose: closeModal
    });
	};

	const rowActions = (rowData): JSX.Element => {
		return (
			<div
				onClick={(): void => setFeeModalState({ isOpen: true, partnerFeeData: rowData?.original })}
				className="text-center text-muted cursor-pointer fs-7 d-flex align-items-center justify-content-center"
			>
				<FontAwesomeIcon icon={faPenToSquare}/>
				<div className="ms-2 fs-6 fw-bolder">Edit</div>
			</div>
		);
	};

	return (
		<>
			<SectionWrapper
				title={t('PARTNERS.PARTNER_FEES')}
				// sectionAdditionalClass="mb-5"
				sectionBodyAdditionalClass="py-0"
				isCardBody
				headerAdditionalBlock={<ButtonComponent
					buttonName="Add"
					additionalClass="btn-sm"
					onButtonClick={(): void => setFeeModalState({ isOpen: true })}
				/>}
			>
				<Table
					name={TablesNames.partnerFeesTableData}
					data={partnerFees}
					isLoading={isPartnerDetailsDataLoading}
					enableDensityToggle={false}
					enableFullScreenToggle={false}
					enableHiding={false}
					enableRowActions={true}
					rowActions={rowActions}
					actionColumnsSize={50}
					positionActionsColumn="last"
				/>
			</SectionWrapper>

			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
			<ModalWindow
				isOpen={feeModalState.isOpen}
				modalTitle={feeModalState?.partnerFeeData ? 'Edit partner fee' : 'Add partner fee'}
				onClose={closeFeeModal}
				backdrop="static"
				// size="md"
				content={
				<PartnerDetailsFeesModal
					closeModal={closeFeeModal}
					onSuccess={handleSuccess}
					onError={handleError}
					partnerFeeData={feeModalState?.partnerFeeData}
				/>}
			/>
		</>
	);
};